// ----------------- FETCH USER PRODUCTS -----------------
export const FETCH_USER_PRODUCTS_LOADING = 'FETCH_USER_PRODUCTS_LOADING';
export const FETCH_USER_PRODUCTS_SUCCESS = 'FETCH_USER_PRODUCTS_SUCCESS';
export const FETCH_USER_PRODUCTS_ERROR = 'FETCH_USER_PRODUCTS_ERROR';
